import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "travel_group_details"
};
const _hoisted_2 = {
  class: "base_details_content"
};
const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "产品信息", -1);

const _hoisted_5 = {
  class: "base_details_content_second"
};
const _hoisted_6 = {
  key: 0,
  class: "base_details_title"
};
const _hoisted_7 = {
  key: 1,
  class: "base_details_content_second"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "拼单信息", -1);

const _hoisted_9 = {
  class: "base_details_content_second"
};
import BackTitleView from "@com/BackTitleView.vue";
import { ref } from "vue";
import { $msg, $box } from "@ui/msg";
import useRoute from "@util/router";
import CancelOrder from "@com/order/CancelOrder.vue";
import api from "@api/order";
export default {
  __name: 'TravelGroupDetails',

  setup(__props) {
    const route = useRoute();
    const urlQuery = route.query();
    const data = ref({
      groupItem: {},
      // 产品信息
      orderList: [] // 拼单列表

    });
    getData();

    function getData() {
      api.detail('travelGroup', urlQuery.code, val => {
        data.value = val;
        getConfig(val.groupItem.groupStatus);
      });
    }

    const statusTitle = ref("已完成"); // 1034001 拼团中、1034002 已过期、1034003 待接团、1034004 已接团、1034005 已取消

    function getConfig(status) {
      switch (status) {
        case "1034001":
          statusTitle.value = "拼团中";
          break;

        case "1034002":
          statusTitle.value = "已过期";
          break;

        case "1034003":
          statusTitle.value = "待接团";
          break;

        case "1034004":
          statusTitle.value = "已接团";
          break;

        case "1034005":
          statusTitle.value = "已取消";
      }
    }

    function acceptOrder() {
      $box.open("二次已确认", "是否二次已确认？", () => {
        api.confirm('travelGroup', urlQuery.code, () => {
          $msg.succ("二次已确认成功");
          getData();
        }, msg => {
          $box.open("二次已确认失败", msg);
        });
      });
    }

    const cancelOrderRef = ref("");

    function cancelOrder() {
      cancelOrderRef.value.show();
    }

    function getCancelOrder(data) {
      api.cancel({
        type: 'travelGroup',
        code: urlQuery.code,
        // amount: data.amount,
        remark: data.reason
      }, () => {
        $msg.succ("取消成功");
        getData();
      });
    }

    function back() {
      route.go(-1);
    }

    return (_ctx, _cache) => {
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");

      const _component_el_image = _resolveComponent("el-image");

      const _component_el_descriptions = _resolveComponent("el-descriptions");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: `订单详情-${statusTitle.value}`
        }, null, 8, ["title"]), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_descriptions, null, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "拼团编号："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.groupItem.groupCode), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "产品编号："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.groupItem.travelCode), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "产品名称："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.groupItem.travelName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "图片："
            }, {
              default: _withCtx(() => [_createVNode(_component_el_image, {
                src: data.value.groupItem.mainPic,
                class: "image"
              }, null, 8, ["src"])]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "状态："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(statusTitle.value), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "出行日期："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.groupItem.travelDate), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "基地："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.groupItem.shopName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "成团人数："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.groupItem.expectNum), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "当前人数："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.groupItem.currentNum), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "剩余名额："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.groupItem.surplusNum), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "承接人："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.groupItem.confirmBy), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "承接时间："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.groupItem.confirmTime), 1)]),
              _: 1
            })]),
            _: 1
          })]), statusTitle.value == '已取消' ? (_openBlock(), _createElementBlock("div", _hoisted_6, "取消原因")) : _createCommentVNode("", true), statusTitle.value == '已取消' ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(data.value.groupItem.cancelReason), 1)) : _createCommentVNode("", true), _hoisted_8, _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_table, {
            data: data.value.orderList
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "订单编号",
              prop: "orderCode",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "套餐名称",
              prop: "packageName",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "参团时间",
              prop: "createTime",
              align: "center"
            })]),
            _: 1
          }, 8, ["data"])])])])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [statusTitle.value == '待接团' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: acceptOrder,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("二次已确认")]),
            _: 1
          })) : _createCommentVNode("", true), statusTitle.value == '拼团中' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: cancelOrder
          }, {
            default: _withCtx(() => [_createTextVNode("取消订单")]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("关闭")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(CancelOrder, {
        ref_key: "cancelOrderRef",
        ref: cancelOrderRef,
        onCancelOrder: getCancelOrder
      }, null, 512)]);
    };
  }

};